import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DetailPageLayout, { DetailSection } from '../utils/DetailPageLayout';

function SingleChartContent(props) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const url = `${process.env.REACT_APP_API_BASE_URL}/api/charts/${id}`;

  useEffect(() => {
    setIsLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => setHasError(err))
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (isLoading) {
    return (
      <>
        <div className="detail-page"><p>Loading...</p></div>
      </>
    );
  }

  if (hasError || !data) {
    return (
      <>
        <div className="detail-page"><p>Could not load this chart.</p></div>
      </>
    );
  }

  const meta = [];
  const typeLabel = [data.DocType, data.SubType].filter(Boolean).join(' / ');
  if (typeLabel) meta.push({ label: 'Type', value: typeLabel });

  const imgUrl = data.Filename ? `${process.env.REACT_APP_API_BASE_URL}/img/documents/${data.Filename}` : null;

  return (
    <>
      <DetailPageLayout
        eyebrow="Chart"
        title={data.Description || 'Untitled Chart'}
        meta={meta}
      >
        {imgUrl && (
          <DetailSection title="Image">
            <img src={imgUrl} alt={data.Description || 'Chart'} />
          </DetailSection>
        )}

        {data.Notes && (
          <DetailSection title="Notes">
            <p>{data.Notes}</p>
          </DetailSection>
        )}

        {(data.Source_Notes || data.Source_Site) && (
          <DetailSection title="Source">
            <p>
              {data.Source_Notes}
              {data.Source_Site && (
                <>
                  {data.Source_Notes ? ' — ' : ''}
                  <a href={data.Source_Site} target="_blank" rel="noopener noreferrer">{data.Source_Site}</a>
                </>
              )}
            </p>
          </DetailSection>
        )}
      </DetailPageLayout>
    </>
  );
}

export default SingleChartContent;
